// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2020-01-29 08:36:33 +0100 (Wed, 29 Jan 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 107282 $
//  Purpose   : example for wiki templates
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'

// ---Globals
export const statistic = {
  match: ({tag}) => tag == 'SomeWikiTag',
  build: ({attrib}) => <SomeReactComp {...attrib}>123</SomeReactComp>,
  completion: ({}) => {
    return {
      '!top': ['SomeWikiTag'],
      Statistic: {
        attrs: {
          prop1: ['domain.', 'datatype.', 'metadata.'],
        },
      },
    }
  },
}
